var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.872345 2.73397C0.872345 1.28862 2.04403 0.116943 3.48937 0.116943H23.7713V8.84035H3.48937C2.04403 8.84035 0.872345 7.66867 0.872345 6.22333V2.73397Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0426 0.116943H36.4202C37.8656 0.116943 39.0372 1.28862 39.0372 2.73396V6.22333C39.0372 7.66867 37.8656 8.84035 36.4202 8.84035H27.0426V0.116943Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.867 24.1062H3.48937C2.04403 24.1062 0.872354 25.2779 0.872354 26.7232V30.2126C0.872354 31.6579 2.04403 32.8296 3.48938 32.8296H12.867V24.1062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1383 24.1062H36.4202C37.8656 24.1062 39.0372 25.2779 39.0372 26.7232V30.2126C39.0372 31.6579 37.8656 32.8296 36.4202 32.8296H16.1383V24.1062Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.05319,
    y: 12.1118,
    width: 33.8032,
    height: 8.7234,
    rx: 2.61702,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleLanding);
export default __webpack_public_path__ + "static/media/schedule-landing.81ee6779e1d7845ecde58c3f4ed31f8d.svg";
export { ForwardRef as ReactComponent };